"use client";
import { useState, type ReactNode } from "react";
import Link from "next/link";
import { SiIgdb } from "react-icons/si";
import { MdInfoOutline } from "react-icons/md";
import TextModal from "@/components/ui/TextModal";
import vglogo from "../../../assets/vglogo.svg";
import Image from "next/image";
import pack from "../../../package.json";
import { cn } from "@/lib/utils";

export default function DefaultTemplate({ children }: { children: ReactNode }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="flex p-4 h-16 w-full bg-deep-purple-700">
        <div className="flex gap-4 items-center">
          <Image src={vglogo} alt="Vidya Grid Logo" className="h-12 w-12" />
        </div>
        <div className="flex gap-1 ml-auto items-center">
          <MdInfoOutline
            data-testid="help-btn"
            className="cursor-pointer h-6 w-6 hover:scale-105"
            onClick={() => {
              setShowModal(!showModal);
            }}
          />
        </div>
      </div>
      <main
        className={cn(
          "p-2",
          "gap-4",
          "flex flex-col",
          "items-center justify-center",
          "h-[90vh]"
        )}
      >
        {children}
      </main>
      <div
        className={cn([
          "flex",
          "justify-center",
          "items-center",
          "h-10",
          "bg-deep-purple-700",
          "fixed",
          "bottom-0",
          "w-full",
          "p-2",
          "text-center",
        ])}
      >
        <Link
          href="https://www.igdb.com/"
          target="_blank"
          className={cn([
            "hover:underline",
            "flex",
            "items-center",
            "gap-2",
            "text-white",
          ])}
        >
          <h6>Videogame data kindly provided by</h6>
          <SiIgdb className="h-10 w-10" />
        </Link>
      </div>

      <TextModal
        showModal={showModal}
        onClose={() => {
          setShowModal(false);
        }}
        title={`How to play Vidya Grid (v${pack.version})`}
        text={[
          "Each row and column of the grid provides a clue about the video game in that cell.",
          "Click on a cell to choose a video game that matches the clues for that row and column.",
          "Use the search bar to search for video games and the dropdown menu to select your guess.",
          "If your guess is wrong, you'll lose one of your lives.",
          "If you guess correctly, you'll be taken back to the grid, and the cover for your guess will be displayed there.",
          "Keep guessing until you fill the entire grid!",
        ]}
      />
    </>
  );
}
